import { setLocale } from 'yup';

/**
 * Mensagens padrão do Yup em pt-BR.
 *
 * Sem isto, qualquer schema que não passe mensagem explícita renderiza o
 * default em inglês ("installments[0].amount must be a `number` type…"),
 * que hoje chega ao usuário via toast na Calculadora Completa
 * (Steps/Step2.tsx, getFirstError). Ver .context/docs/02-architecture.md §10.
 *
 * Importado uma única vez em src/app/App.js. Schemas com mensagem própria
 * não são afetados. Os textos evitam `${path}` técnico ("installments[0]…")
 * para não vazar nome de campo interno na UI.
 */
setLocale({
  mixed: {
    default: 'Valor inválido.',
    required: 'Campo obrigatório.',
    oneOf: 'Valor não permitido.',
    notOneOf: 'Valor não permitido.',
    notType: ({ type }: { type: string }) => {
      if (type === 'date') return 'Data inválida. Use o formato DD/MM/AAAA.';
      if (type === 'number') return 'Informe um número válido.';
      return 'Valor inválido.';
    },
    defined: 'Campo obrigatório.',
  },
  string: {
    length: 'Deve ter exatamente ${length} caracteres.',
    min: 'Deve ter pelo menos ${min} caracteres.',
    max: 'Deve ter no máximo ${max} caracteres.',
    matches: 'Formato inválido.',
    email: 'E-mail inválido.',
    url: 'URL inválida.',
    uuid: 'Identificador inválido.',
    trim: 'Não pode começar nem terminar com espaços.',
    lowercase: 'Deve estar em letras minúsculas.',
    uppercase: 'Deve estar em letras maiúsculas.',
  },
  number: {
    min: 'Deve ser maior ou igual a ${min}.',
    max: 'Deve ser menor ou igual a ${max}.',
    lessThan: 'Deve ser menor que ${less}.',
    moreThan: 'Deve ser maior que ${more}.',
    positive: 'Deve ser um número positivo.',
    negative: 'Deve ser um número negativo.',
    integer: 'Deve ser um número inteiro.',
  },
  date: {
    min: 'A data deve ser posterior a ${min}.',
    max: 'A data deve ser anterior a ${max}.',
  },
  array: {
    min: 'Informe pelo menos ${min} item(ns).',
    max: 'Informe no máximo ${max} item(ns).',
  },
  boolean: {},
  object: {},
});
